import React from "react";
import QuoteForm from "@/components/site/QuoteForm";
import { COMPANY, whatsappLink } from "@/data/constants";

export const ContactSection = ({ formRef }) => {
  return (
    <section id="contato" data-testid="contact-section" className="mn-section bg-white">
      <div className="mn-container grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <span className="mn-eyebrow">Fale conosco</span>
          <h2 className="mn-h-display text-[2.25rem] sm:text-[2.5rem] lg:text-[3rem] mt-4 leading-tight">
            Vamos elevar a presença <br className="hidden md:block" />
            <span style={{ color: "var(--mn-gold)" }}>da sua marca.</span>
          </h2>
          <p className="mt-5 text-[var(--mn-dark)] leading-relaxed">
            Preencha o formulário e nossa consultoria entra em contato em poucas horas. Para urgências, fale diretamente no WhatsApp.
          </p>

          <div className="mt-9 space-y-6">
            <div className="flex items-start gap-4">
              <span className="w-11 h-11 inline-flex items-center justify-center border border-[var(--mn-gold)] text-[var(--mn-gold)] rounded-sm">
                <i className="fa-brands fa-whatsapp" />
              </span>
              <div>
                <div className="text-[0.7rem] uppercase tracking-[0.24em] font-semibold text-[var(--mn-dark)]">WhatsApp</div>
                <a
                  href={`https://wa.me/${COMPANY.phonesRaw[0]}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block font-serif-display font-bold text-xl text-[var(--mn-black)] hover:text-[var(--mn-gold)] transition-colors"
                  data-testid="contact-whatsapp"
                >
                  {COMPANY.phonesDisplay[0]}
                </a>
                <a
                  href={`https://wa.me/${COMPANY.phonesRaw[1]}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block font-serif-display font-bold text-xl text-[var(--mn-black)] hover:text-[var(--mn-gold)] transition-colors mt-1"
                  data-testid="contact-whatsapp-2"
                >
                  {COMPANY.phonesDisplay[1]}
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="w-11 h-11 inline-flex items-center justify-center border border-[var(--mn-gold)] text-[var(--mn-gold)] rounded-sm">
                <i className="fa-solid fa-phone" />
              </span>
              <div>
                <div className="text-[0.7rem] uppercase tracking-[0.24em] font-semibold text-[var(--mn-dark)]">Telefone fixo</div>
                <a
                  href={`tel:+${COMPANY.landlineRaw}`}
                  className="block font-serif-display font-bold text-xl text-[var(--mn-black)] hover:text-[var(--mn-gold)] transition-colors"
                  data-testid="contact-landline"
                >
                  {COMPANY.landlineDisplay}
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="w-11 h-11 inline-flex items-center justify-center border border-[var(--mn-gold)] text-[var(--mn-gold)] rounded-sm">
                <i className="fa-brands fa-instagram" />
              </span>
              <div>
                <div className="text-[0.7rem] uppercase tracking-[0.24em] font-semibold text-[var(--mn-dark)]">Instagram</div>
                <a
                  href={COMPANY.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-serif-display font-bold text-xl text-[var(--mn-black)] hover:text-[var(--mn-gold)] transition-colors"
                  data-testid="contact-instagram"
                >
                  {COMPANY.instagramHandle}
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="w-11 h-11 inline-flex items-center justify-center border border-[var(--mn-gold)] text-[var(--mn-gold)] rounded-sm">
                <i className="fa-solid fa-location-dot" />
              </span>
              <div>
                <div className="text-[0.7rem] uppercase tracking-[0.24em] font-semibold text-[var(--mn-dark)]">Endereço</div>
                <p className="font-medium text-[var(--mn-black)] leading-relaxed max-w-xs mt-1">{COMPANY.address}</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="w-11 h-11 inline-flex items-center justify-center border border-[var(--mn-gold)] text-[var(--mn-gold)] rounded-sm">
                <i className="fa-solid fa-credit-card" />
              </span>
              <div>
                <div className="text-[0.7rem] uppercase tracking-[0.24em] font-semibold text-[var(--mn-dark)]">Pagamento</div>
                <p className="font-medium text-[var(--mn-black)] mt-1">PIX · Débito · Crédito</p>
              </div>
            </div>
          </div>
        </div>

        <div ref={formRef} className="lg:col-span-7">
          <QuoteForm />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
